import { InjectionToken } from '@angular/core';

import type { ActionType } from '@ngrx/store';

export const IntegrationsMailboxLinkInsertedActionToken = new InjectionToken<ActionType<any>>(
  'IntegrationsMailboxLinkInsertedActionToken',
);
